import axiosInstance from './axiosInstance';

// UI events are explicitly client-reported, not proof of a server mutation/download.
export function reportMisActivity(action, tab, details = {}) {
  if (!window.crypto?.randomUUID) return;
  void axiosInstance.post('/mis-audit/events', {
    ...details, action, tab, eventId: window.crypto.randomUUID(),
  }, { skipSessionRedirect: true, timeout: 6000 }).catch(() => {
    console.warn('MIS activity could not be recorded.');
  });
}
